import type { ConsentStatus } from './consent.types';

/**
 * The words every consent surface uses. The Consent tab cards, the Lead Info
 * rail, and the contacts-table tooltips all read from here so the same state
 * is never described three different ways.
 */
export const CONSENT_STATUS_LABEL: Record<ConsentStatus, string> = {
  opted_in: 'Opted in',
  opted_out: 'Opted out',
  dnc: 'Do not contact',
  unknown: 'Not captured',
};

/** Precedes the date the state was set. Null where there is nothing to date. */
export const CONSENT_DATE_LABEL: Record<ConsentStatus, string | null> = {
  opted_in: 'Granted',
  opted_out: 'Revoked',
  // A suppression carries no transition timestamp, so there is no date to label.
  dnc: null,
  unknown: null,
};
